import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";
import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";
import { on } from "delegated-events";
import ajax from "@common/ajax";
import { scrollToIfNeeded } from "@common/scroll-to";
import { generateQueryString } from "@common/util";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.reset();
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  updateResults();

  document.body.classList.remove("is-searching");
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollToIfNeeded(pageContent, 24);
  } else {
    form.classList.remove("is-filtered");
  }

  setupFeaturedSlider();
};

const setupFeaturedSlider = () => {
  const slider = document.querySelector(".featured-testimonials");

  if (slider) {
    const container = slider.querySelector(".swiper");
    const numSlides = slider.querySelectorAll(".swiper-slide").length;

    new Swiper(container, {
      modules: [A11y, Autoplay, Pagination],
      slidesPerView: 1,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      speed: 1000,
      pagination: {
        el: slider.querySelector(".slider-pagination"),
        clickable: true,
      },
      watchSlidesProgress: numSlides <= 3,
      breakpoints: {
        768: {
          centeredSlides: numSlides > 3,
          slidesPerView: 2,
        },
        1700: {
          centeredSlides: numSlides > 3,
          slidesPerView: 3,
        },
      },
    });
  }
};

const init = () => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    on("change", ".filter-form select", handleFilterChange);
    on("submit", ".filter-form", handleFilterChange);
    on("click", ".filter-form-clear", handleFilterClear);
  }

  setupFeaturedSlider();
};

init();
